import api from '@/api'

export default {
  async updateUser({commit}, userInfo) {
    let data = await api.user.updateUser(userInfo)
    data.id = data.userId
    data.name = data.userName
    commit('setUserInfo', Object.assign(userInfo || {}, data))
    return data
  },
  async checkUserNeedModifyInfo({commit}) {
    return await api.user.checkUserNeedModifyInfo()
  }
}
